// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"5e34ef0a","348":"43711efe","401":"758582f7","577":"d0da6ff9","833":"6bb34914","975":"3598e23f"}[chunkId] + ".chunk.js";
};